import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/b35c7df1-9005-4ee3-95f7-d68a29ad0407.jpg';
const guarantees = ['Sin experiencia previa', 'Acceso inmediato', '7 días de garantía'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-cream" data-id="element-101" data-mp="1297cu5rar3ad">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 py-14 sm:py-20 lg:grid-cols-2 lg:gap-14" data-id="element-102" data-mp="127eereur1rdz">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-103" data-mp="sbb5lp1hcshj">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-light px-4 py-1.5 text-sm font-semibold text-brand-dark" data-id="element-104" data-mp="neawf59c39m7">
            <ZapIcon className="h-4 w-4" data-id="element-105" data-mp="381xmf1kmf8br" /> Programa 100% Online · Acceso inmediato
          </span>

          <h1 className="mt-5 font-display text-4xl font-bold leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-106" data-mp="3j7zg1kyg9whq">
            Camina y Transforma tu Cuerpo
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink/70" data-id="element-107" data-mp="3o59efq3thihp">
            El método paso a paso para bajar de peso caminando — sin dietas
            extremas, sin gimnasio, sin excusas.
          </p>

          <div className="mt-8" data-id="element-108" data-mp="30iazwxz9ckmf">
            <CtaButton trackingEvent="Lead" data-id="element-109" data-mp="30gzvcvxzn8u9">VER OFERTA Y PRECIO</CtaButton>
          </div>

          <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2" data-id="element-110" data-mp="358zoo5jjz3hv">
            {guarantees.map(g => <li key={g} className="flex items-center gap-2 text-sm font-medium text-ink/70" data-id="element-111" data-mp="2qkwjuzh8xxun">
                <CheckIcon className="h-4 w-4 text-brand" data-id="element-112" data-mp="2vi50gvmqxtts" /> {g}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.15
      }} className="relative" data-id="element-113" data-mp="2hjypl8wm14p9">
          <div className="overflow-hidden rounded-[2rem] shadow-2xl shadow-brand/20 ring-1 ring-black/5" data-id="element-114" data-mp="s3usu27hfid9">
            <img src={HERO_IMG} alt="Mujer caminando feliz por un parque soleado" className="h-full w-full object-cover" data-id="element-115" data-mp="ic87hd1fk2ws" />
          </div>
          <div className="absolute -bottom-5 -left-4 rounded-2xl bg-white px-5 py-4 shadow-xl ring-1 ring-black/5 sm:-left-6" data-id="element-116" data-mp="dbastafmpr01">
            <p className="text-2xl font-extrabold text-brand" data-id="element-117" data-mp="161b0fh1ili6l">+2.800</p>
            <p className="text-xs font-medium text-ink/60" data-id="element-118" data-mp="112pwb6j56ecv">Personas transformadas</p>
          </div>
        </motion.div>
      </div>
    </section>;
}